/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateDefaultInstrumentRequest} from '@cash-web/protos/squareup/cash/cashlynxflow/plasma/v1/update_default_instrument.pb'
import {UpdateDefaultInstrumentResponse} from '@cash-web/protos/squareup/cash/cashlynxflow/plasma/v1/update_default_instrument.pb'


export const updateDefaultInstrumentV2 = (request: UpdateDefaultInstrumentRequest, options?: CashRequestOptions) => post<UpdateDefaultInstrumentRequest, UpdateDefaultInstrumentResponse>("/2.0/cash/update-default-instrument-v2", request, {...options, rejectOnError: true })